<div *transloco="let t">
  <footer aria-labelledby="footer-heading" class="border-top-1 border-gray-100">
    <div class="pt-5 pb-3 lg:pb-0">
      <div class="w-10 m-auto">
        <div class="flex py-3 flex-wrap flex-column md:flex-row gap-5 justify-content-between">
          <div class="sm:m-auto m-auto">
            <img src="assets/images/logo-apprezzo.svg" alt="Logo" />
            <p
              class="m-0 text-sm text-center text-gray-600 font-normal"
              [innerHTML]="t('homepage.content.hero_1.subtitle1')"></p>

            <div class="social flex mt-5 lg:mt-8 justify-content-center">
              <div>
                <a
                  href="https://www.facebook.com/61575810205249"
                  target="_blank"
                  class="text-white">
                  <i class="pi pi-facebook"></i>
                </a>
              </div>
              <div>
                <a
                  href="https://www.instagram.com/apprezzoo"
                  target="_blank"
                  class="text-white ml-3">
                  <i class="pi pi-instagram"></i>
                </a>
              </div>
              <div>
                <a href="https://www.tiktok.com/@apprezzoo" target="_blank" class="text-white ml-3">
                  <i class="pi pi-tiktok"></i>
                </a>
              </div>
              <div>
                <a
                  href="https://it.pinterest.com/apprezzoo/"
                  target="_blank"
                  class="text-white ml-3">
                  <i class="pi pi-pinterest"></i>
                </a>
              </div>
              <div>
                <a
                  href="https://www.youtube.com/@Apprezzoo"
                  target="_blank"
                  class="text-white ml-3">
                  <i class="pi pi-youtube"></i>
                </a>
              </div>
              @if(platform === 'web') {
              <div>
                <a
                  href="https://play.google.com/store/apps/details?id=com.apprezzoo"
                  target="_blank"
                  class="text-white ml-3">
                  <i class="pi pi-android"></i>
                </a>
              </div>
              <div>
                <a
                  href="https://apps.apple.com/it/app/apprezzoo/id6744108858"
                  target="_blank"
                  class="text-white ml-3">
                  <i class="pi pi-apple"></i>
                </a>
              </div>
              }
            </div>
          </div>
          <div class="flex flex-1 gap-8 justify-content-center lg:justify-content-end">
            <div class="flex-1 hidden lg:block" style="justify-items: end">
              <h3
                class="text-sm text-right font-semibold text-gray-500 tracking-wider uppercase mt-0">
                Menu
              </h3>

              <nav class="flex flex-column gap-1 text-right">
                <div *ngIf="items$ | async as items">
                  <ng-container
                    *ngIf="isLoggedIn$ | async; then privateMenu; else publicMenu"></ng-container>

                  <ng-template #privateMenu>
                    <ng-container *ngFor="let item of items">
                      <a
                        *ngIf="item['private']"
                        [routerLink]="['/dashboard/', item.url]"
                        pRipple
                        class="text-sm text-gray-500 hover:text-gray-600 block mb-1">
                        <span>
                          {{ item.label }}
                        </span>
                      </a>
                    </ng-container>
                  </ng-template>

                  <ng-template #publicMenu>
                    <ng-container *ngFor="let item of items">
                      <a
                        *ngIf="!item['private']"
                        [routerLink]="['/', item.url]"
                        pRipple
                        class="text-sm text-gray-500 hover:text-gray-600 block mb-1">
                        <span>
                          {{ item.label }}
                        </span>
                      </a>
                    </ng-container>
                  </ng-template>
                </div>
              </nav>
            </div>
            <div class="lg:block justify-content-center">
              <h3
                class="text-center lg:text-right text-sm font-semibold text-gray-500 tracking-wider uppercase mt-0">
                {{ t('breadcrumb.useful-links') }}
              </h3>
              <nav class="flex flex-column gap-1 text-center lg:text-right">
                <a
                  class="text-sm text-gray-500 hover:text-gray-600"
                  href="https://blog.apprezzoo.it/">
                  {{ t('breadcrumb.blog') }}
                </a>
                <a
                  class="text-sm text-gray-500 hover:text-gray-600"
                  [routerLink]="'/' + t('routes.terms-and-conditions')">
                  {{ t('breadcrumb.terms-and-conditions') }}
                </a>
                <a
                  class="text-sm text-gray-500 hover:text-gray-600"
                  [routerLink]="'/privacy-policy'">
                  {{ t('breadcrumb.privacy-information') }}
                </a>
                <a
                  class="text-sm text-gray-500 hover:text-gray-600"
                  [routerLink]="'/cookie-policy'">
                  {{ t('breadcrumb.cookie-policy') }}
                </a>
                <cookie-consent-component></cookie-consent-component>
              </nav>
            </div>
          </div>
        </div>
        <div
          class="border-t py-3 text-center flex justify-content-center gap-5 border-top-1 border-gray-300">
          <span class="text-xs text-gray-500">
            Digital Company di Sadik Fatima Zahra - via Augusta n° 33, 96100 Siracusa - P.I.
            02081350890
          </span>
        </div>
      </div>
    </div>
  </footer>
</div>
